import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { TenantProvider } from './context/TenantContext';
import { PermissionsProvider } from './context/PermissionsContext';
import Layout from './components/Layout/Layout';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import InstrumentsPage from './pages/InstrumentsPage';
import InstrumentDetailPage from './pages/InstrumentDetailPage';
import ReportsPage from './pages/ReportsPage';
import CalibrationsPage from './pages/CalibrationsPage';
import AssetsPage from './pages/AssetsPage';
import CalendarPage from './pages/CalendarPage';
import SettingsPage from './pages/SettingsPage';
import AuditPage from './pages/AuditPage';
import LoopsPage from './pages/LoopsPage';
import ClassesPage from './pages/ClassesPage';
import UsersPage from './pages/UsersPage';
import PadroesReferenciaPage from './pages/PadroesReferenciaPage';
import InstrumentPublicPage from './pages/InstrumentPublicPage';
import VerificacoesPage from './pages/VerificacoesPage';
import OrcamentosPage from './pages/OrcamentosPage';
import AdminEmpresasPage from './pages/AdminEmpresasPage';
import TrocarSenhaPage from './pages/TrocarSenhaPage';

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-8">Carregando...</div>;
  if (!user) return <Navigate to="/login" />;
  if (user.mustChangePassword) return <Navigate to="/trocar-senha" />;
  return children;
}

export default function App() {
  return (
    <ThemeProvider>
    <AuthProvider>
      <PermissionsProvider>
      <TenantProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/trocar-senha" element={<TrocarSenhaPage />} />
          <Route path="/p/:id" element={<InstrumentPublicPage />} />
          <Route
            element={
              <PrivateRoute>
                <Layout />
              </PrivateRoute>
            }
          >
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/assets" element={<AssetsPage />} />
            <Route path="/instruments" element={<InstrumentsPage />} />
            <Route path="/instruments/:id" element={<InstrumentDetailPage />} />
            <Route path="/calibrations" element={<CalibrationsPage />} />
            <Route path="/calendar" element={<CalendarPage />} />
            <Route path="/reports" element={<ReportsPage />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="/loops" element={<LoopsPage />} />
            <Route path="/classes" element={<ClassesPage />} />
            <Route path="/padroes-referencia" element={<PadroesReferenciaPage />} />
            <Route path="/verificacoes" element={<VerificacoesPage />} />
            <Route path="/orcamentos" element={<OrcamentosPage />} />
            <Route path="/usuarios" element={<UsersPage />} />
            <Route path="/audit" element={<AuditPage />} />
            <Route path="/admin/empresas" element={<AdminEmpresasPage />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
      </TenantProvider>
      </PermissionsProvider>
    </AuthProvider>
    </ThemeProvider>
  );
}